export const capitalizeFirstLetter = (word: string): string =>
  `${word[0].toUpperCase()}${word.slice(1)}`;

export const capitalizeFirstLetterOfEachWord = (word: string): string =>
  word
    .split('-')
    .map((wordValue) => capitalizeFirstLetter(wordValue))
    .join('-');
